import {
  ACCEPTED_FILE_TYPES,
  MAX_FILE_SIZE_MB,
  MAX_FILE_UPLOAD_COUNT,
  PLANS_NAME,
} from "./config";
import productOverviewBackground from "@assets/images/product-overview-background-r4.svg";
import productOverviewBasicShieldBackground from "@assets/images/product-overview-basicshield.png";
import porductOverViewBGEvergreen from "@assets/images/evergreen-bg-productoverview.png";
import porductOverViewBGCCP from "@assets/images/ccp-bg-productoverview.png";
import { Step } from "@pages/ShieldStarter/Components/Stepper";
import { ROUTE_PATH } from "./route-paths";
import { ConsentTypes } from "@redux/slices/SHIELD_STARTER/step3Slice";
import { EverGreenStyle } from "@utils/Style/everGreen";

export interface IContentData {
  heading: string;
  description: string;
  features: string[];
  brouchureUrl: string;
  findOutMoreUrl: string;
  disclaimer: string;
  backgroundUrl: string;
  primaryColor?: string;
  bgWidth?: number;
  bgHeight?: number;
}

interface IContent {
  [key: string]: IContentData;
}

//Static content that will be used in product overview hover component, which user hover's over the what is plan link
export const CONTENT: IContent = {
  [PLANS_NAME.MLTC]: {
    heading: "Singlife CareShield Standard/Plus?",
    description:
      "Enhance your CareShield Life or ElderShield policy coverage with Singlife CareShield for greater financial assurance.",
    features: [
      "Additional payouts for severe disability from S$200 to S$5,000 more on top of basic severe disability payouts from the government",
      "Stop paying your premiums but remain covered when you have a mild disability, meaning you are unable to perform at least one Activity of Daily Living (ADL)",
      "Pick your preferred premium payment period up to the policy anniversary until you are 99, or for a limited time",
    ],
    brouchureUrl: "AVIVA_VARIABLE_CONFIG.brochureUrlMltc",
    findOutMoreUrl: "https://singlife.com/en/disability-insurance/careshield",
    disclaimer: "",
    backgroundUrl: productOverviewBackground,
  },
  [PLANS_NAME.SHIELD_STARTER]: {
    heading: "Singlife Shield Starter and Health Plus Starter",
    description:
      "The only medical insurance plan in Singapore that gives you basic, entry-level hospitalisation coverage at affordable premiums.",
    features: [
      "Get <span style='font-weight:600'>up to S$20,000 coverage</span> for inpatient and outpatient hospital treatment costs",
      "<span style='font-weight:600'>Add on just S$1 a year</span> for a rider, when you purchase Singlife Shield Starter (S$300, premiums payable with MediSave)*",
      "Enjoy <span style='font-weight:600'>guaranteed acceptance at age 40</span> for Singlife Shield Plan 2 and Health Plus, which offer a prevailing coverage of up to S$1 million",
    ],
    brouchureUrl: "AVIVA_VARIABLE_CONFIG.brochureUrlShieldStarter",
    findOutMoreUrl:
      "https://singlife.com/en/medical-insurance/singlife-shield-starter-and-health-plus",
    disclaimer: "*Premiums quoted before GST.",
    backgroundUrl: productOverviewBasicShieldBackground,
  },
  [PLANS_NAME.EVER_GREEN]: {
    heading: "dynamicPath:everGreenStep1.staticData.productName", // This checks the store path to update the title. update the title in the store.
    description:
      "It is a Single Premium (SP), non-participating endowment plan which provides a guaranteed Maturity Benefit at the end of the policy term!",
    features: [
      "Guaranteed yield of - per annum^",
      "Guaranteed issuance - No need to undergo medical check-up to apply",
      "Minimum of S$20,000 single premium using cash or Supplementary Retirement Scheme (SRS) funds",
    ],
    brouchureUrl: "AVIVA_VARIABLE_CONFIG.brochureUrlEvergreen",
    findOutMoreUrl: "https://singlife.com/en/savings/digital-saver",
    disclaimer:
      "^The guaranteed yield of # per annum upon maturity is based on the Life Assured surviving until the end of the policy term with no surrender or claims made during the entire policy term.",
    backgroundUrl: porductOverViewBGEvergreen,
    primaryColor: EverGreenStyle.colors.primary,
    bgHeight: 514,
  },
  [PLANS_NAME.CANCER_COVER_PLUS]: {
    heading: "Singlife Cancer Cover Plus II?", // This checks the store path to update the title. update the title in the store.
    description:
      "A medical plan that offers protection against large medical bills from cancer treatments that can significantly reduce your out-of-pocket cancer treatment expenses both locally and overseas.",
    features: [
      "<span style='font-weight:600'>Covers outpatient cancer drug treatment and services</span> - Including Proton Beam Therapy and Cell, Tissue and Gene Therapy.",
      "<span style='font-weight:600'>As-charged coverage of up to S$1.5 mil</span> - Have greater peace of mind knowing your out-of-pocket expenses are significantly",
      "<span style='font-weight:600'>Easy and fast application</span> - Sign up by answering 3 simple health questions with no medical check-up needed.",
    ],
    brouchureUrl: "AVIVA_VARIABLE_CONFIG.brochureUrlCCP",
    findOutMoreUrl:
      "https://singlife.com/en/medical-insurance/singlife-cancer-cover-plus-ii",
    disclaimer: "",
    backgroundUrl: porductOverViewBGCCP,
  },
};

interface IContentVIew {
  legends: string[];
  disclaimers: string[];
}
interface IContentViewQuotationObjet {
  [key: string]: IContentVIew;
}

export const CONTENT_VIEW_QUOTATION_DISCLAIMER: IContentViewQuotationObjet = {
  [PLANS_NAME.SHIELD_STARTER]: {
    disclaimers: [
      "There is a 21-day free-look period after you've received the policy contract.",
      "Total distribution costs are not applicable if this product is bought directly from us without financial advice and no Financial Adviser Representative is assigned for the servicing of this policy, either by yourself or Singlife.",
      "If there are insufficient funds in your MediSave account, the remaining premium will be charged to the credit card you have provided.",
      "For Singlife Shield products, please refer to the Product Summary for the Additional Withdrawal Limits (AWLs) for Singaporeans and Permanent Residents. We will attempt to deduct the maximum withdrawal amount from the designated CPF Medisave account.",
      "Anyone who pays for, or is insured under Singlife Shield Starter and Health Plus Starter is not eligible for Additional Premium Support (APS) from the Government.* If you are currently receiving APS to pay for your MediShield Life and/or CareShield Life premiums, and you choose to be insured under this Singlife Shield Starter and Health Plus Starter policy, you will stop receiving APS. This applies even if you are not the person paying for this Singlife Shield Starter and Health Plus Starter policy. In addition, if you choose to be insured under this Singlife Shield Starter and Health Plus Starter policy, the person paying for Singlife Shield Starter and Health Plus Starter will stop receiving APS, if he or she is currently receiving APS.",
    ],
    legends: [
      "* APS is for families who need assistance with MediShield Life and/or CareShield Life premiums, even after receiving premium subsidies and making use of MediSave to pay for these premiums.",
    ],
  },
};

export const STEPS_LIST: Step[] = [
  {
    id: "basic_info",
    label: "Basic Info",
    path: ROUTE_PATH.SHIELD_STARTER_GET_QUOTE,
  },
  {
    id: "plan_quote",
    label: "Plan & Quote",
    path: ROUTE_PATH.SHIELD_STARTER_CHOOSE_PLAN,
  },
  {
    id: "personal_info ",
    label: "Personal Info ",
    path: ROUTE_PATH.SHIELD_STARTER_START_APPLICATION,
  },
  {
    id: "medical_history",
    label: "Medical History",
    path: ROUTE_PATH.SHIELD_STARTER_HEALTH_DECLARATION,
  },
  {
    id: "review_payment",
    label: "Review & Payment",
    path: ROUTE_PATH.SHIELD_STARTER_REVIEW,
  },
];
export const EVER_GREEN_STEP_LIST: Step[] = [
  {
    id: "invest_calc",
    label: "Your Quote",
    path: ROUTE_PATH.EVER_GREEN_QUOTATION,
  },
  {
    id: "personal_detail",
    label: "Personal Info",
    path: ROUTE_PATH.EVER_GREEN_MY_INFO,
  },
  {
    id: "declaration ",
    label: "Declaration",
    path: ROUTE_PATH.EVER_GREEN_OCCUPATION,
  },
  {
    id: "payment",
    label: "Review & Payment",
    path: ROUTE_PATH.EVER_GREEN_TAX_DECLARATION,
  },
];

export const CCP_STEP_LIST: Step[] = [
  {
    id: "basic_info",
    label: "Basic Info",
    path: ROUTE_PATH.CANCER_COVER_BASIC_INFO,
  },
  {
    id: "your_quote",
    label: "Your Quote",
    path: ROUTE_PATH.CANCER_COVER_QUOTATION_SUMMARY,
  },
  {
    id: "health_declaration",
    label: "Health Declaration",
    path: ROUTE_PATH.CANCER_COVER_UW_1A,
  },
  {
    id: "application_details",
    label: "Application Details",
    path: ROUTE_PATH.CANCER_COVER_MY_INFO,
  },
  {
    id: "review_payment",
    label: "Review & Payment",
    path: ROUTE_PATH.CANCER_COVER_REVIEW,
  },
];

export const CONSENT_ACCEPT_DECLARATION: any = {
  [ConsentTypes.PARENT]:
    "I hereby authorise my child/ward to use his/her own Medisave for the purpose of buying an Integrated Shield Plan for himself/herself and/or his/her dependant(s).",
  [ConsentTypes.GUARDIAN]:
    "I hereby authorise my child/ward to use his/her own Medisave for the purpose of buying an Integrated Shield Plan for himself/herself and/or his/her dependant(s).",
  [ConsentTypes.NEITHER]:
    "I declare that I do not have any parent or legal guardian to authorise the use of my Medisave to pay for this application.",
};

export const CONSENT_LABEL: any = {
  [ConsentTypes.PARENT]: "Parent",
  [ConsentTypes.GUARDIAN]: "Legal Guardian",
  [ConsentTypes.NEITHER]: "Neither",
};

export const FILE_INSTRUCTIONS = [
  {
    label: "No. of file",
    value: `${MAX_FILE_UPLOAD_COUNT} file(s) only`,
  },
  {
    label: "File size limit",
    value: `Up to ${MAX_FILE_SIZE_MB}`,
  },
  {
    label: "Supported file formats",
    value: ACCEPTED_FILE_TYPES,
  },
];

export const DEFAULT_DISCLAIMER_MSG =
  "^The premium payable may differ by a few cents due to rounding differences.";
export const DISCLAIMER_TEXT =
  "*Refer to policy schedule for breakdown and payment amount for subsequent years premium.";
